import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import SEO from '../../components/SEO';
import { customerAuthApi } from '../../services/customerAuthApi';
import { useAuth } from '../../context/AuthContext';
import './AuthPage.css';

function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords don\'t match.'); return; }
    setSubmitting(true);
    try {
      // SEC-06 Phase 5: server sets customer_session + csrf_token
      // cookies on the reset response. refresh() picks up the new
      // session via the boot /me call.
      await customerAuthApi.reset({ token, password });
      await refresh();
      navigate('/account', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  // Rendered in both branches so the "invalid link" state (which is what the
  // pre-render sees, having no token) still carries a title and noindex.
  const seo = <SEO title="Reset password" description="Choose a new password for your ASG Shading account using the link we emailed you." canonical="/reset-password" noindex />;

  if (!token) {
    return (
      <div className="auth-page">
        {seo}
        <div className="auth-card">
          <h1 className="auth-title">Invalid link</h1>
          <p className="auth-subtitle">This reset link looks broken. Try requesting a new one.</p>
          <p className="auth-meta-center"><Link to="/forgot-password">Get a new reset link</Link></p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      {seo}
      <div className="auth-card">
        <p className="auth-eyebrow">ASG Shading</p>
        <h1 className="auth-title">Set a new password</h1>
        <p className="auth-subtitle">Choose a password with at least 8 characters.</p>
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="auth-field">
            <label htmlFor="password">New password</label>
            <input id="password" type="password" autoComplete="new-password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <div className="auth-field">
            <label htmlFor="confirm">Confirm password</label>
            <input id="confirm" type="password" autoComplete="new-password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          {error && <p className="auth-error" role="alert">{error}</p>}
          <button type="submit" className="auth-btn" disabled={submitting}>
            {submitting ? 'Saving…' : 'Save new password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
